import { render, staticRenderFns } from "./VithasLegal.vue?vue&type=template&id=f512e890&scoped=true"
import script from "./VithasLegal.vue?vue&type=script&lang=js"
export * from "./VithasLegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f512e890",
  null
  
)

export default component.exports